import { BasicFormValues } from '@util/registration/BasicFormModel'

const initialFormValues: BasicFormValues = {
    firstName: '',
    lastName: '',
    email: '',
    password: '',
    repeatPassword: '',
    birthday: undefined,
    gender: undefined,
    bornIn: undefined,
    livingIn: undefined,
    terms: false,
}

export { initialFormValues }
